import Service from './Service'
import { PROGRAM } from './apiUrls'

export default class ProgramService extends Service {
  getGeo (query) {
    return this.axios.get('geo-programs', {params: query})
  }
  getGeoRegions (query) {
    return this.axios.get('geo-regions', {params: query})
  }
  getStock (query) {
    return this.axios.get('stocks', {params: query})
  }
  getExport (query) {
    return this.axios.get('programs-export', {params: query})
  }
  patchAll (query, data) {
    return this.axios.patch(`${PROGRAM}`, data, {params: query})
  }
  getOneDiffusion (id, query) {
    return this.axios.get(`${PROGRAM}/${id}/diffusion`, {params: query})
  }
  postDiffusion (id, data) {
    return this.axios.post(`${PROGRAM}/${id}/diffusion`, data)
  }
  deleteDiffusion (id, data) {
    return this.axios.delete(`${PROGRAM}/${id}/diffusion`)
  }
}



// WEBPACK FOOTER //
// ./src/services/api/ProgramService.js